import React from 'react';
import { AvatarHero } from '../sections/AvatarHero.jsx';
import { BioHeader } from '../sections/BioHeader.jsx';
import { SocialStrip } from '../sections/SocialStrip.jsx';
import { ResumeTimeline } from '../sections/ResumeTimeline.jsx';
import { PortfolioGallery } from '../sections/PortfolioGallery.jsx';
import { ContactSection } from '../sections/ContactSection.jsx';
import { GlobalFooter } from '../sections/GlobalFooter.jsx';
import { colors, spacing } from '../../../design-system/index.js';

const PersonalSite = () => {
  const siteStyles = {
    minHeight: '100vh',
    backgroundColor: colors.background.primary,
    color: colors.text.primary,
    fontFamily: 'Inter, sans-serif',
  };

  const containerStyles = {
    maxWidth: spacing.layout.containerMaxWidth,
    margin: '0 auto',
    padding: `0 ${spacing[6]}`,
  };

  return (
    <div style={siteStyles}>
      <main style={containerStyles}>
        <AvatarHero />
        <BioHeader />
        <SocialStrip />
        <ResumeTimeline />
        <PortfolioGallery />
        <ContactSection />
      </main>
      <GlobalFooter />
    </div>
  );
};

export default PersonalSite;
